/* tslint:disable */
/* eslint-disable */
/**
 * CMS API
 * The CMS API!
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { EntitlementType } from './entitlement-type';
import { LocalizedFieldBody } from './localized-field-body';
import { TargetPlatform } from './target-platform';
import { UiModuleExperimentGroup } from './ui-module-experiment-group';

/**
 * 
 * @export
 * @interface TournamentListUiModuleBody
 */
export interface TournamentListUiModuleBody {
    /**
     * 
     * @type {string}
     * @memberof TournamentListUiModuleBody
     */
    moduleId?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentListUiModuleBody
     */
    slug?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentListUiModuleBody
     */
    hash?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentListUiModuleBody
     */
    moduleType: TournamentListUiModuleBodyModuleTypeEnum;
    /**
     * 
     * @type {Array<TargetPlatform>}
     * @memberof TournamentListUiModuleBody
     */
    targetPlatform?: Array<TargetPlatform>;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof TournamentListUiModuleBody
     */
    caption?: LocalizedFieldBody;
    /**
     * 
     * @type {Array<EntitlementType>}
     * @memberof TournamentListUiModuleBody
     */
    entitlements?: Array<EntitlementType>;
    /**
     * 
     * @type {Array<UiModuleExperimentGroup>}
     * @memberof TournamentListUiModuleBody
     */
    experiments?: Array<UiModuleExperimentGroup> | null;
    /**
     * 
     * @type {LocalizedFieldBody}
     * @memberof TournamentListUiModuleBody
     */
    title: LocalizedFieldBody;
    /**
     * 
     * @type {string}
     * @memberof TournamentListUiModuleBody
     */
    templateUrlPath: string;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentListUiModuleBody
     */
    tournamentIds: Array<string>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentListUiModuleBody
     */
    tournamentReferenceIds?: Array<string>;
}

/**
    * @export
    * @enum {string}
    */
export enum TournamentListUiModuleBodyModuleTypeEnum {
    TOURNAMENT_LIST = 'TOURNAMENT_LIST'
}



